import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { RowsOfSlidersExample, SlidersOnTwoRowsExample, ControlAsComponent } from '../../components/examples/controls-examples';
export const _frontmatter = {
  "Title": "Arranging controls"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "arranging-controls"
    }}>{`Arranging controls`}</h1>
    <h2 {...{
      "id": "presenting-default-controls-on-several-rows-and-columns"
    }}>{`Presenting default controls on several rows and columns`}</h2>
    <p>{`Instead of passing just one control object, you can pass an array of control objects.
Each item of the array will be a different row.`}</p>
    <RowsOfSlidersExample mdxType="RowsOfSlidersExample" />
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "type": "range",
    "label": "A",
    "name": "a",
    "param": "a"
  },
  {
    "type": "range",
    "label": "B",
    "name": "b",
    "param": "b"
  },
  {
    "type": "range",
    "label": "C",
    "name": "c",
    "param": "c"
  }
]
`}</code></pre>
    <p>{`But you can also arrange your sliders on two rows, like so:`}</p>
    <SlidersOnTwoRowsExample mdxType="SlidersOnTwoRowsExample" />
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  [
    {
      "type": "range",
      "label": "A",
      "name": "a",
      "param": "a"
    }
  ],
  [
    {
      "type": "range",
      "label": "B",
      "name": "b",
      "param": "b"
    },
    {
      "type": "range",
      "label": "C",
      "name": "c",
      "param": "c"
    }
  ]
]
`}</code></pre>
    <h2 {...{
      "id": "arranging-controls-as-components"
    }}>{`Arranging controls as components`}</h2>
    <p>{`You've seen in `}<a parentName="p" {...{
        "href": "/react-sim/custom-controls"
      }}>{`custom controls`}</a>{` how you can make your own control components.
You can also import the pre-defined types:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {
  Checkbox,
  Input,
  Radio,
  Range,
  Select,
  Timer,
  Toggle,
} from 'react-sim';
`}</code></pre>
    <p>{`You can now use these as Components and arrange them freely.`}</p>
    <ControlAsComponent mdxType="ControlAsComponent" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const MyCustomRange = ({ params, setParams }) => {
  const value = params['my-param'];
  const setValue = v => setParams({ 'my-param': v });
  return (
    <Range
    label="My range"
      value={value}
      setValue={setValue}
      minValue={0}
      maxValue={100}
      step={1}
    />
  );
};
const CustomRange = withControls(MyCustomRange);

export const ControlAsComponent = () => (
  <Model
    showTimer={false}
    initialParams={{ 'my-param': 50 }}
  >
    <Flex flexDirection="column">
      <CustomFrame />
      <CustomRange />
    </Flex>
  </Model>
);
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      